export const MUSIC_VERSIONING_OVERLAY_CLASSNAME = 'music-versioning-overlay'
